// Listing plans shown on /listing-plans. This mirrors the coastal directory's
// plan structure: three recurring subscription tiers plus a short-term
// placement boost. Everything here is editable from Admin Console → Listing
// Plans on the live site (this file is only the offline/preview fallback).
export const plans = [
  {
    id: "plan-free",
    slug: "free",
    name: "Free",
    tagline: "Get discovered with a basic listing, free for the first year.",
    price: 0,
    period: "forever",
    validity: "For Ever",
    icon: "ri-store-3-line",
    ctaLabel: "Get Started Free",
    isPopular: false,
    group: "subscription",
    chips: ["1 category", "3 photos"],
    features: [
      "1 business listing",
      "List in 1 Category",
      "Up to 3 photos",
      "Phone & WhatsApp button",
      "Appears in search & category pages",
      "Basic business details & map",
    ],
  },
  {
    id: "plan-business",
    slug: "business",
    name: "Business",
    tagline: "For growing businesses that want a steady flow of leads.",
    price: 599,
    period: "year",
    validity: "12 months",
    icon: "ri-rocket-2-line",
    ctaLabel: "Upgrade to Business",
    isPopular: true,
    group: "subscription",
    chips: ["1 category", "4 sub categories", "7 photos"],
    features: [
      "1 verified listing",
      "List in 1 Main Category and 4 Other Categories",
      "1 featured image + 7 photos gallery",
      "Website & social links",
      "Lead dashboard & enquiry alerts",
      "Enhanced SEO metadata",
      "Verified badge on your profile",
    ],
  },
  {
    id: "plan-premium",
    slug: "premium",
    name: "Premium",
    tagline: "Maximum visibility, priority ranking and advanced analytics.",
    price: 1599,
    period: "year",
    validity: "12 months",
    icon: "ri-vip-crown-2-line",
    ctaLabel: "Upgrade to Premium",
    isPopular: false,
    group: "subscription",
    chips: ["3 categories", "6 sub categories", "9 photos", "Video tour"],
    features: [
      "1 verified listing",
      "List in 3 Main Categories and 6 Other Categories",
      "1 featured image + 9 photos gallery + 1 video",
      "Featured listing eligibility",
      "Remaining features from the Business plan",
      "Priority ranking in relevant results",
    ],
  },
  {
    id: "plan-sponsored",
    slug: "sponsored-listing",
    name: "Sponsored Listing",
    tagline: "Display everywhere — homepage and across your district, taluk and category pages.",
    price: 1999,
    period: "year",
    validity: "45 days",
    icon: "ri-megaphone-line",
    ctaLabel: "Upgrade to Sponsored Listing",
    isPopular: false,
    group: "placement",
    chips: ["3 categories", "6 sub categories", "10 photos", "Video tour"],
    features: [
      "Homepage featured placement",
      "Top of your district & taluk pages",
      "Priority position in 3 chosen categories",
      "Sponsored badge across the site",
    ],
  },
];